(()=>{
 const dialog=document.querySelector('#gs-search-filter-dialog');if(!dialog)return;
 const form=dialog.querySelector('form'),back=dialog.querySelector('.gs-search-filter-back'),title=dialog.querySelector('h2'),reset=dialog.querySelector('.gs-search-filter-reset');
 const inputs=[...form.querySelectorAll('input[type="checkbox"],input[type="number"]')];
 const panels=[...dialog.querySelectorAll('[data-search-filter-panel]')];
 // Same short length labels as category filters; retain every original value.
 document.querySelectorAll('.gs-search-check-list').forEach(list=>{
  const first=list.querySelector('input');
  if(!first||!/filter\.p\.m\.(kettenlaenge|armbandlaenge)\./.test(first.name)||!window.gsrSearchLengthParser)return;
  const groups=new Map();
  [...list.querySelectorAll('label')].forEach(label=>{
   const input=label.querySelector('input'),text=label.querySelector('span'),info=gsrSearchLengthParser.normalize(input.value);
   const entry=groups.get(info.key);
   if(entry){
    entry.inputs.push(input);entry.checked=entry.checked||input.checked;entry.count+=Number(label.querySelector('small').textContent.replace(/\D/g,''))||0;
    label.hidden=true;input.dataset.gsrLengthAlias='true';
   }else groups.set(info.key,{label,input,text,info,inputs:[input],checked:input.checked,count:Number(label.querySelector('small').textContent.replace(/\D/g,''))||0});
  });
  groups.forEach(g=>{
   g.text.textContent=g.info.label;g.label.querySelector('small').textContent='('+g.count+')';
   g.inputs.forEach(i=>i.checked=g.checked);
   g.input.addEventListener('change',()=>g.inputs.forEach(i=>i.checked=g.input.checked));
  });
 });
 let current='root',opener=null;
 const show=id=>{
  current=id;panels.forEach(p=>p.hidden=p.dataset.searchFilterPanel!==id);
  back.hidden=id==='root';title.textContent=id==='root'?'FILTER':panels.find(p=>p.dataset.searchFilterPanel===id)?.dataset.filterTitle.toUpperCase();
  dialog.querySelector('.gs-search-filter-panels').scrollTop=0;
 };
 const sync=()=>{
  reset.hidden=!inputs.some(i=>i.type==='checkbox'?i.checked:i.value!=='');
  for(const p of panels.filter(p=>p.dataset.searchFilterPanel!=='root')){
   const selected=[...p.querySelectorAll('input[type=checkbox]:checked:not([data-gsr-length-alias])')].map(i=>i.nextElementSibling.textContent.trim());
   const values=[...p.querySelectorAll('input[type=number]')].map(i=>i.value);
   const row=dialog.querySelector('[data-filter-summary="'+p.dataset.searchFilterPanel+'"]');
   if(row)row.textContent=selected.join(', ')||(values.some(Boolean)?(values[0]||'0')+'–'+(values[1]||'…')+' €':'');
  }
 };
 document.querySelector('.gs-search-filter-open')?.addEventListener('click',e=>{opener=e.currentTarget;show('root');dialog.showModal()});
 dialog.querySelector('.gs-search-filter-close').addEventListener('click',()=>dialog.close());
 back.addEventListener('click',()=>show('root'));
 dialog.addEventListener('click',e=>{
  const next=e.target.closest('[data-search-filter-next]');
  if(next)show(next.dataset.searchFilterNext);
  if(e.target.closest('.gs-search-filter-apply')){sync();show('root')}
  if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}
 });
 reset.addEventListener('click',()=>{inputs.forEach(i=>i.type==='checkbox'?i.checked=false:i.value='');sync();show('root')});
 form.addEventListener('change',sync);
 dialog.addEventListener('close',()=>{opener?.focus({preventScroll:true});show('root')});
 dialog.addEventListener('cancel',e=>{if(current!=='root'){e.preventDefault();show('root')}});
 document.querySelectorAll('.gs-search-desktop-filter,.gs-search-sort-form,#gs-search-filter-dialog form').forEach(f=>f.addEventListener('submit',()=>{
  f.querySelectorAll('input[type=number]').forEach(i=>i.disabled=i.value==='');
 }));
 document.querySelector('.gs-search-sort-form select')?.addEventListener('change',e=>e.target.form.requestSubmit());
 document.querySelectorAll('.gs-search-filter-dropdown').forEach(d=>d.addEventListener('toggle',()=>{
  if(d.open)document.querySelectorAll('.gs-search-filter-dropdown').forEach(other=>{if(other!==d)other.open=false});
 }));
 sync();
})();
